import { Instagram, Facebook, Twitter, Heart } from "lucide-react";

const quickLinks = [
  { name: "Home", href: "#home" },
  { name: "Meet Masky", href: "#meet-masky" },
  { name: "Passport", href: "#passport" },
  { name: "How It Works", href: "#how-it-works" },
  { name: "Pricing", href: "#pricing" },
  { name: "FAQs", href: "#faqs" },
  { name: "Contact", href: "#contact" },
];

export default function Footer() {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#0A1A2F] text-white" data-testid="footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/32qtaxsv_Design.png"
                alt="Masky"
                className="h-12 w-12 object-contain masky-glow-sm"
              />
              <div>
                <h3 className="font-bold text-xl font-['Montserrat']">Fighting Fit Fencing</h3>
                <p className="text-white/60 text-sm font-['Lato']">Ofsted Registered</p>
              </div>
            </div>
            <p className="text-white/70 leading-relaxed font-['Lato']">
              An informal and friendly fencing club based in London. 
              Building confidence and making fencing fun for ages 6-16!
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-6 font-['Montserrat']">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-white/70 hover:text-[#D4A857] transition-colors font-['Lato']"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="font-bold text-lg mb-6 font-['Montserrat']">Get In Touch</h4>
            <div className="space-y-3 text-white/70 font-['Lato']">
              <p>
                <span className="text-white font-['Montserrat']">Phone:</span>{" "}
                <a href="tel:+442036375707" className="hover:text-[#D4A857]">
                  020 3637 5707
                </a>
              </p>
              <p>
                <span className="text-white font-['Montserrat']">Email:</span>{" "}
                <a
                  href="mailto:admin@ukswordfencing.com"
                  className="hover:text-[#D4A857]"
                >
                  admin@ukswordfencing.com
                </a>
              </p>
              <p>
                Dedicated fencing venue, Barnet EN5 4DJ
              </p>
            </div>

            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a
                href="https://instagram.com/fightingfitfencing"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#D4A857] hover:text-[#0A1A2F] transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://facebook.com/fightingfitfencing"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#D4A857] hover:text-[#0A1A2F] transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://twitter.com/fightingfitfencing"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#D4A857] hover:text-[#0A1A2F] transition-colors"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm font-['Lato']">
              © {new Date().getFullYear()} Fighting Fit Fencing. All rights reserved.
            </p>
            <p className="text-white/60 text-sm flex items-center gap-1 font-['Lato']">
              Made with <Heart size={14} className="text-[#D4A857]" /> for young fencers
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
